<template>
  <div class="template_1">
      <div v-if="!loading">
        <fieldset v-for="(set, setIndex) in fields" :key="setIndex">
  
          <legend>
            <span class="number">{{set.number}}</span>
            <span class="desc">
              <p class="ltitle">{{set.name}}</p>
              <p class="dtxt" v-if="set.desc != ''"> {{ set.desc }} </p>
            </span>
          </legend>
  
          <div class="temp-row" v-for="(row, rowIndex) in fieldRows[setIndex]" :key="rowIndex">
            <div class="temp-input" 
              v-for="(field, index) in row" style="flex:1"
              :key="index">
    
              <label :for="field.name" v-if="!['hidden'].includes(field.type)">{{ field.label }}</label>
              
              <p class="rdtl" v-html="formData[field.name]" v-if="!['image'].includes(field.type)"></p>
              <div class="imgs" v-if="['image'].includes(field.type)">
                <img v-for="(prv,prIndex) in formData[field.name]"
                  :key="prIndex"
                  :src="prv"/>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="errors" v-if="!loading">
        <p v-for="(e,i) in errors" :key="i">{{e}}</p>
      </div>
      

      <div class="temp-row submit-btn" v-if="loading" >
        <img src="@/assets/img/ajldr.gif" style="width:100px"/>
      </div>
  </div>
</template>
  
  
<script>
import { ref, computed, defineComponent, onMounted, watchEffect } from 'vue';

export default defineComponent({
  props: {
    fields: {
      type: Array,
      required: true
    },
    columns: {
      type: Number,
      default: 1 // Number of columns per row
    },
    loading:{
      type:Boolean,
      default:false,
    },
    errors:{
      type:Array
    }
  },
  setup(props, { emit }) {
    const formData = ref({}); // To hold form data

    // Helper function to initialize or reinitialize form data
    const initializeFormData = () => {
      const data = {};
      props.fields.forEach(set => {
        set.data.forEach(field => {
          data[field.name] = field.value || ''; // Assign initial values or empty string
        });
      });
      formData.value = data; // Update formData
    };

    // Initialize form data on mount
    onMounted(initializeFormData);

    // Use watchEffect to reactively update formData when fields prop changes
    watchEffect(() => {
      initializeFormData(); // Reinitialize form data when fields change
    });

    // Computed property for splitting fields into rows based on columns
    const fieldRows = computed(() => {
      const rows = [];
      props.fields.forEach(set => {
        const rowsForSet = [];
        for (let i = 0; i < set.data.length; i += props.columns) {
          rowsForSet.push(set.data.slice(i, i + props.columns));
        }
        rows.push(rowsForSet);
      });
      return rows;
    });

    // Handle form submission
    const handleSubmit = () => {
      emit('submit', { ...formData.value}); // Emit form data to parent component
    };

    const sendData = () => {
      emit('sendData', { ...formData.value});
    };

    return { formData, fieldRows, handleSubmit,sendData };
  }
});
</script>


<style scoped>
*, *:before, *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body {font-family: 'Nunito', sans-serif; color: var(--black);}
p,label{color: var(--black);}
.temp-row{display: flex; gap: 5px;}
form {width:100%}

h1 {margin: 0 0 30px 0;text-align: center;}

input[type="text"],
input[type="password"],
input[type="date"],
input[type="datetime"],
input[type="email"],
input[type="number"], :deep(.input),
input[type="search"],
input[type="tel"],
input[type="time"],
input[type="url"],
textarea,.rdtl,
select {
  background: rgba(255,255,255,0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: var(--input-bg);
  color: #8a97a0;
  box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
  margin: 5px 0;
}

input[type="radio"],
input[type="checkbox"] {
  margin: 0 4px 8px 0;
}

select {
  padding: 15px;
  border-radius: 2px;
}

.submit-btn{display:flex; justify-content: center; width:100%;padding: 0 15px;}
button {width:100%; font-weight: 500;
  background: var(--primary-color);
  color: var(--white-color);
  box-shadow: none;
  border: 0;
  margin: 20px 40px;
  padding: 19px 39px 18px 39px;
  font-size: 18px;
  text-align: center;
  font-style: normal;
  border-radius: 5px;
}

fieldset {
  margin-bottom: 10px;
  border: none;
  padding: 0px 15px;
}

legend {margin-bottom: 10px; display: flex; align-items: center;}
legend .desc{margin-left:5px}
legend .ltitle{font-size: 1.4em; margin: 0; line-height: 1em; font-weight: bold;}
legend .dtxt{font-size: 13px; margin:0}

label {display: block; font-size: 14px; font-weight: bold;}

label.light {
  font-weight: 300;
  display: inline;
}

.number {
  background-color: var(--primary-color);
  color: var(--white-color);
  height: 30px;
  width: 30px;
  display: inline-block;
  font-size: 0.8em;
  margin-right: 4px;
  line-height: 30px;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255,255,255,0.2);
  border-radius: 100%;
}
.errors{padding: 0px 15px;}
.errors p{background:red; color:white; margin:5px; padding:5px 10px;
  border-radius: 10px; font-weight: bold; font-size: 14px;}
.success p{background: green;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: bold;}
.imgs{display:flex; gap:5px; flex-wrap: wrap;}
.imgs img{width:min(150px, 50%)}
</style>
  